<template>
  <div class="page-aboutUs">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="../../assets/image/story_banner.png" />
      <ul class="content">
        <li>
          <div class="title">
            <router-link to="/about/story">
              <p id="world">半个世纪的故事</p>
            </router-link>
          </div>
        </li>
        <li class="active">
          <div class="title">
            <p>爱在中国</p>
          </div>
        </li>
        <li>
          <div class="title">
            <router-link to="/about/belief">
              <p>KRK信念</p>
            </router-link>
          </div>
        </li>
      </ul>
    </div>
    <div class="china-section">
      <div class="header w1200 clearfix">
        <div class="header-left">
          <div class="hr"></div>
          <h2>爱在中国</h2>
          <h3>Since 2014</h3>
        </div>
        <div class="header-right">Love in China</div>
      </div>
      <!-- <div class="p-div div1 w1200">
        <div class="left">
          <h2>Kids 'R' Kids 品牌进入中国，源于爱。</h2>
          <p class="p">
            2012年，美国名校留学归来的Grant开始思考一个大多数父母都思考过的问题：如何为孩子寻找一所理想的幼儿园。带着这份对女儿沉沉的父爱，他考察了近百所国内的幼儿园，可是总觉得缺少了点什么。直到有一次在美国考察时，Grant遇到了美国知名连锁幼儿园品牌Kids 'R' Kids。
            <br />
            <br />透过全透明的教室玻璃墙，他看到几个月大的宝宝在地毯上爬来爬去，老师们有的趴在地毯上与宝宝们互动，有的安详地坐在摇椅上喂宝宝喝奶，脸上挂着幸福的笑容。这一幕至今仍深深印刻在他的脑海。
            <br />
            <br />通过进一步的了解，创始人Pat Vinson老先生所倡导的“Hug First, Then Teach”（先拥抱，再启迪）的教学理念深深打动了Grant；Kids 'R' Kids在过去50多年来一直以孩子为中心、低调做宣传、踏实做教育的大爱之心，更是让他有一种相见恨晚之感。
          </p>
        </div>
        <div class="right bg1">
          <div class="bg"></div>
          <img src="../../assets/image/love_img1.png" />
        </div>
      </div>
      <div class="p-div2">
        <div class="w1200">
          <div class="left bg2">
            <div class="bg"></div>
            <img src="../../assets/image/love_img2.png" />
          </div>
          <div class="right bg1">
            <h2>Grant认定，Kids 'R' Kids就是他理想中的幼儿园。</h2>
            <p>他希望自己的女儿在家门口就能上Kids 'R' Kids，更希望让更多的中国孩子在婴幼儿阶段同样能享受这样的成长体验。心之所向，使命必达。幸运的他终于实现了自己的愿望，并为此放弃了商业管理的职业方向，与志同道合的伙伴一起，投身到教育事业。</p>
          </div>
        </div>
      </div>-->
      <div class="p-div div3 w1200">
        <div class="left">
          <h2>2014年5月，Kids 'R' Kids品牌正式进入中国并亮相纽约时代广场，总部落户北京望京SOHO。</h2>
          <p class="p">
            作为最早进入中国的纯正美国幼儿园品牌，Kids 'R' Kids获得了极大的关注。基于对幼儿教育事业的严谨态度，Kids 'R' Kids中国团队选择了稳扎稳打、精耕细作的发展风格，始终坚守着Kids 'R' Kids品牌“一切以孩子为中心”的价值观。
            <br />
            <br />2015年9月，Kids 'R' Kids北京旗舰园在朝阳公园附近低调开园。一路走来，旗舰园高素质的管理和教师团队，凭借用心、爱心和专业，赢得好评如潮。现如今在金台路附近又开新园，满足越来越多认可Kids 'R' Kids理念的家庭的入园需求。
            <br />
            <br />截至2018年底，Kids 'R' Kids已进入北京、上海、南京、天津、广州、长沙、南通等多个城市，开设近20家国际幼儿园。每一家幼儿园几乎都成为当地地标，成为区域市场中最受家长们追随的高端国际幼儿园之一。
            <br />
            <br />带着一个想做中国最有温度的国际幼儿园的初心，让我们一起回顾Kids 'R' Kids在中国的发展历程。
          </p>
        </div>
        <div class="right bg1">
          <div class="bg"></div>
          <img src="../../assets/image/love_img3.png" />
        </div>
      </div>
      <div class="milestone-bg">
        <h1>MILESTONE</h1>
      </div>
      <div class="milestone w1200">
        <div class="axios">
          <div class="start" v-show="isStart"></div>
          <div
            class="dot"
            :class="genDot(index)"
            v-for="(dot,index) in timesData"
            :key="index"
            v-if="index > 0"
          >
            <div class="line"></div>
            <div class="circle"></div>
          </div>
          <div class="continue">
            <div class="line"></div>
            <div class="circle"></div>
            <p>to be continued</p>
          </div>
        </div>
        <ul class="clearfix">
          <li v-for="(item,index) in timesData" :key="index">
            <h2>{{item.time}}</h2>
            <p>{{item.content}}</p>
            <img v-if="item.img" :src="item.img" />
          </li>
        </ul>
      </div>
    </div>
    <!--底部-->
    <v-footer></v-footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header' // 悬浮头部
import Footer from '@/components/footer/footer' // 底部模块
import timeData from '../../../static/mock/times.json'

export default {
  data () {
    return {
      isStart: false,
      isMore: false,
      isContinue: false,
      timesData: [],
      page: 1,
      size: 10
    }
  },
  components: {
    Header,
    'v-footer': Footer
  },
  mounted () {
    this.getTimeline()
  },
  methods: {
    getTimeline () {
      // 获取时间轴数据
      let param = {
        // page: this.page,
        // size: this.size
      }
      if (timeData.code === '00') {
        this.isMore = false
        this.timesData = this.timesData.concat(timeData.data.list)
        if (this.page == 1 && this.timesData.length > 0) {
          this.isStart = true
        }
        if (timeData.data.total > this.page * this.size) {
          this.isMore = true
          this.isContinue = false
        } else {
          this.isMore = false
          this.isContinue = true
        }
      }
    },
    next () {
      this.page++
      this.getTimeline()
    },
    genDot (index) {
      return 'dot' + (parseInt(index) + 1)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-aboutUs {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          #world {
            width: 236px;
            height: 68px;
          }
          p {
            width: 163px;
            height: 68px;
            font-size: 24px;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
          }
        }
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
    }
  }
  .china-section {
    width: 100%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    .w1200 {
      width: 1200px !important;
      margin: 0 auto;
    }
    .header {
      width: 1200px;
      overflow: hidden;
      margin-top: 85px;
      .header-left {
        float: left;
        .hr {
          width: 96px;
          height: 4px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          width: 375px;
          height: 96px;
          font-size: 48px;
          font-weight: 500;
          color: #333333;
          line-height: 96px;
        }
        h3 {
          width: 142px;
          height: 29px;
          line-height: 29px;
          background: rgba(174, 149, 79, 1);
          font-size: 24px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: bold;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
        }
      }
      .header-right {
        float: left;
        margin-top: 16px;
        margin-left: 400px;
        height: 73px;
        font-size: 73px;
        font-family: TimesNewRomanPS-ItalicMT;
        font-style: italic;
        font-weight: normal;
        color: rgba(204, 204, 204, 1);
        line-height: 73px;
        text-align: left;
      }
    }
    .p-div {
      clear: both;
      height: 500px;
      padding-top: 91px;
      padding-bottom: 93px;
      .left {
        float: left;
        width: 547px;
        h2 {
          height: 19px;
          padding-top: 25px;
          padding-bottom: 46px;
          font-size: 18px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
        }
        p {
          width: 547px;
          height: 146px;
          font-size: 16px;
          color: rgba(51, 51, 51, 1);
          line-height: 32px;
        }
      }
      .right {
        float: left;
        margin-left: 95px;
        margin-top: 100px;
        .bg {
          width: 529px;
          height: 353px;
          position: relative;
          left: 26px;
          top: 15px;
          background-color: #0e4082;
        }
        img {
          position: relative;
          top: -353px;
          left: 0px;
          width: 529px;
          height: 353px;
        }
      }
    }
    .p-div.div1 {
      .right {
        height: 390px;
        width: 556px;
        overflow: hidden;
      }
    }
    .p-div2 {
      clear: both;
      height: 464px;
      background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/love/love_bg1.jpg)
        no-repeat;
      .left {
        float: left;
        width: 408px;
        height: 464px;
        .bg {
          position: relative;
          box-sizing: border-box;
          width: 373px;
          height: 435px;
          left: 0px;
          top: 75px;
          border: 20px solid #ae954f;
        }
        img {
          position: relative;
          top: -484px;
          left: 23px;
          width: 408px;
          height: 540px;
        }
      }
      .right {
        float: left;
        margin-left: 181px;
        h2 {
          height: 19px;
          padding-top: 108px;
          padding-bottom: 46px;
          font-size: 18px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
        }
        p {
          width: 547px;
          font-size: 16px;
          color: #333333;
          line-height: 36px;
        }
      }
    }
    .p-div.div3 {
      // padding-top: 156px;
      padding-bottom: 165px;
      height: 480px;
      .left {
        p {
          width: 550px;
          height: 241px;
          padding-top: 20px;
          span.s_down {
            position: relative;
            font-size: 16px;
            font-family: Arial;
            font-weight: 400;
            color: rgba(174, 149, 79, 1);
            line-height: 36px;
          }
          span.s_down::after {
            content: "";
            position: absolute;
            bottom: 5px;
            right: -25px;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid #ae954f;
          }
        }
        h2 {
          width: 800px;
          height: 19px;
          line-height: 20px;
          padding-top: 30px;
          padding-bottom: 36px;
          font-size: 18px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
        }
      }
      .right {
        width: 558px;
        height: 396px;
        overflow: hidden;
        margin-top: 130px;
        .bg {
          width: 539px;
          height: 365px;
          position: relative;
          left: 17px;
          top: 20px;
          background-color: #ae954f;
        }
        img {
          position: relative;
          width: 541px;
          height: 371px;
          top: -371px;
        }
      }
    }
    .milestone-bg {
      height: 299px;
      background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/love/love_bg2.jpg")
        no-repeat center;
      background-size: auto 299px;
      font-size: 90px;
      text-align: center;
      font-family: TimesNewRomanPSMT;
      font-weight: 400;
      color: rgba(250, 249, 249, 1);
      line-height: 194px;
      text-shadow: 2px 3px 8px rgba(6, 1, 2, 0.14);
    }
    .milestone {
      position: relative;
      background: #fff;
      margin-top: -113px;
      .axios {
        position: absolute;
        width: 50px;
        height: auto;
        top: 135px;
        left: 50%;
        margin-top: -25px;
        background: #fff;
        .start {
          width: 50px;
          height: 50px;
          background: url("../../assets/image/clock.png") no-repeat;
          background-size: 50px;
        }
        .more {
          .line {
            width: 4px;
            margin-left: 22px;
            height: 405px;
            background: #ae954f;
          }
          p {
            background: #ae954f;
            height: 44px;
            line-height: 44px;
            cursor: pointer;
            width: 100px;
            margin-left: -32px;
            text-align: center;
          }
        }
        .dot {
          .line {
            width: 4px;
            margin-left: 22px;
            height: 230px;
            background: #ae954f;
          }
          .circle {
            position: relative;
            left: 11px;
            width: 22px;
            height: 22px;
            border: 2px solid #ae954f;
            border-radius: 50%;
            background: #fff;
          }
          .circle::after {
            content: "";
            position: absolute;
            width: 12px;
            height: 12px;
            top: 5px;
            left: 5px;
            border-radius: 50%;
            background: #ae954f;
          }
        }
        .dot.dot2 {
          .line {
            height: 176px;
          }
        }
        .continue {
          .line {
            width: 4px;
            margin-left: 22px;
            height: 405px;
            background: #ae954f;
          }
          .circle {
            position: relative;
            width: 42px;
            height: 42px;
            left: 4px;
            box-sizing: border-box;
            border: 5px solid #ae954f;
            border-radius: 50%;
            background: #fff;
          }
          .circle::after {
            content: "";
            position: absolute;
            width: 19px;
            height: 19px;
            top: 7px;
            left: 7px;
            border-radius: 50%;
            background: #ae954f;
          }
          p {
            height: 19px;
            padding-top: 29px;
            font-size: 24px;
            font-family: PingFang;
            font-weight: 600;
            color: rgba(182, 159, 96, 1);
            width: 200px;
            margin-left: -73px;
            padding-bottom: 109px;
            padding-left: 14px;
          }
        }
      }
      ul {
        width: 100%;
        margin: 0 auto;
        padding-top: 113px;
        padding-bottom: 132px;
        li {
          height: 515px;
          h2 {
            height: 42px;
            font-size: 60px;
            font-family: TimesNewRomanPS-BoldMT;
            font-weight: bold;
            color: rgba(174, 149, 79, 1);
            padding-bottom: 25px;
          }
          p {
            font-size: 24px;
            line-height: 35px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            padding-bottom: 31px;
          }
          img {
            width: 342px;
            height: 215px;
          }
        }
        li:nth-of-type(odd) {
          float: left;
          width: 435px;
          text-align: right;
          margin-left: 133px;
          // margin-top:205px;
        }
        li:nth-of-type(even) {
          float: right;
          width: 435px;
          text-align: left;
          margin-right: 82px;
          // margin-top:205px;
        }
        li:nth-of-type(1) {
          height: 460px;
          margin-top: 0px;
        }
        li:nth-of-type(2) {
          margin-top: 205px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page-aboutUs {
    .banner {
      padding-top: 45px;
      .content {
        width: 100%;
        position: absolute;
        left: 0;
        margin-left: 0;
        bottom: 0;
        height: 35px;
        display: flex;
        white-space: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-backface-visibility: hidden;
        -webkit-perspective: 1000;
        -webkit-overflow-scrolling: touch;
        text-align: justify;
        li {
          width: 100%;
          div.title {
            #world {
              width: auto;
              padding: 0 24px;
              height: 35px;
            }
            p {
              width: auto;
              padding: 0 24px;
              height: 35px;
              font-size: 14px;
              line-height: 35px;
            }
          }
        }
      }
    }
    .china-section {
      width: 100%;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      .w1200 {
        width: 100% !important;
        margin: 0 auto;
      }
      .header {
        width: 100%;
        overflow: hidden;
        margin-top: 35px;
        .header-left {
          width: 100%;
          box-sizing: border-box;
          padding-left: 7.1%;
          .hr {
            width: 56px;
            height: 3px;
          }
          h2 {
            width: 100%;
            height: 41px;
            font-size: 21px;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            font-family: PingFangSC-Medium;
            padding: 10px 0 8px;
            box-sizing: border-box;
          }
          h3 {
            width: 64px;
            height: 20px;
            font-size: 10px;
            font-family: TimesNewRomanPS-BoldItalicMT;
            font-weight: normal;
            line-height: 20px;
            background: rgba(174, 149, 79, 1);
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            padding: 0 5px;
          }
        }
        .header-right {
          display: none;
        }
      }
      .p-div {
        width: 100%;
        display: flex;
        flex-direction: column-reverse;
        height: 645px;
        padding-top: 50px;
        padding-bottom: 0;
        margin-bottom: 35px;
        .left {
          clear: both;
          width: 100%;
          position: static;
          h2 {
            width: 100%;
            box-sizing: border-box;
            height: 30px;
            line-height: 30px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            margin: 0;
            padding: 0 8.9% 0 6.8%;
            margin-bottom: 12px;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding-left: 6.8%;
            padding-right: 8.9%;
            height: 360px;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
          }
        }
        .right {
          width: 100%;
          padding: 0 7.6% 0 8.1%;
          box-sizing: border-box;
          margin: 0;
          margin-bottom: 25px;
          .bg {
            width: 95%;
            height: 200px;
            position: relative;
            left: 10px;
            top: 18px;
            background-color: #0e4082;
            margin: 0;
          }
          img {
            top: -200px;
            left: 0px;
            width: 95%;
            height: auto;
          }
        }
      }
      .p-div.div1 {
        .right {
          height: auto;
          width: 100%;
          overflow: hidden;
        }
      }
      .p-div2 {
        clear: both;
        height: 582px;
        background: none;
        .left {
          float: left;
          width: 100%;
          height: 350px;
          box-sizing: border-box;
          padding: 0 7.6% 0 8.1%;
          .bg {
            position: relative;
            box-sizing: border-box;
            width: 72%;
            height: 279px;
            left: 0px;
            top: 68px;
            border: 10px solid #ae954f;
          }
          img {
            position: relative;
            top: -275px;
            left: -12px;
            width: 80%;
            height: auto;
          }
        }
        .right {
          float: left;
          margin-left: 0;
          h2 {
            width: 100%;
            box-sizing: border-box;
            height: 50px;
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 25px;
            margin-top: 24px;
            margin-bottom: 28px;
            padding: 0;
            padding-left: 7.3%;
            padding-right: 13.4%;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding-left: 6.8%;
            padding-right: 8.9%;
            height: 130px;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
          }
        }
      }
      .p-div.div3 {
        width: 100%;
        display: flex;
        flex-direction: column-reverse;
        height: 775px;
        padding-top: 20px;
        padding-bottom: 0;
        margin-bottom: 35px;
        .left {
          clear: both;
          width: 100%;
          position: static;
          h2 {
            width: 100%;
            box-sizing: border-box;
            height: 90px;
            line-height: 30px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            margin: 0;
            padding: 0 8.9% 0 6.8%;
            margin-bottom: 0;
          }
          p {
            width: 100%;
            box-sizing: border-box;
            padding-left: 6.8%;
            padding-right: 8.9%;
            height: 416px;
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 21px;
          }
        }
        .right {
          width: 100%;
          padding: 0 7.6% 0 8.1%;
          box-sizing: border-box;
          margin: 0;
          .bg {
            width: 95%;
            height: 200px;
            position: relative;
            left: 10px;
            top: 18px;
            background-color: #0e4082;
            margin: 0;
          }
          img {
            top: -200px;
            left: 0px;
            width: 95%;
            height: auto;
          }
        }
      }
      .milestone-bg {
        height: 250px;
        background: url("https://krk-website.oss-cn-beijing.aliyuncs.com/img/love/love_bg2.jpg")
          no-repeat center;
        background-size: 267% 177px;
        background-position: 48% -7%;
        h1 {
          text-align: center;
          text-shadow: 2px 3px 8px rgba(6, 1, 2, 0.14);
          font-size: 41px;
          font-family: TimesNewRomanPSMT;
          font-weight: 400;
          color: rgba(250, 249, 249, 1);
          line-height: 30px;
          text-shadow: 1px 2px 6px rgba(6, 1, 2, 0.14);
          padding-top: 40px;
        }
      }
      .milestone {
        position: relative;
        background: #fff;
        margin-top: -155px;
        width: 85.3% !important;
        .axios {
          position: absolute;
          width: 28px;
          height: auto;
          top: 67px;
          left: 50%;
          margin-left: -14px;
          background: #fff;
          .start {
            width: 22px;
            height: 22px;
            margin-left: 3px;
            background: url("../../assets/image/clock.png") no-repeat;
            background-size: 22px;
          }
          .more {
            .line {
              width: 3px;
              margin-left: 22px;
              height: 405px;
              background: #ae954f;
            }
            p {
              background: #ae954f;
              height: 44px;
              line-height: 44px;
              cursor: pointer;
              width: 100px;
              margin-left: -32px;
              text-align: center;
            }
          }
          .dot {
            .line {
              width: 3px;
              margin-left: 13px;
              height: 129px;
              background: #ae954f;
            }
            .circle {
              position: relative;
              left: 7px;
              width: 14px;
              height: 14px;
              border: 1px solid #ae954f;
            }
            .circle::after {
              content: "";
              position: absolute;
              width: 8px;
              height: 8px;
              top: 3px;
              left: 3px;
            }
          }
          .dot.dot2 {
            .line {
              height: 176px;
            }
          }
          .continue {
            .line {
              width: 3px;
              margin-left: 15px;
              height: 185px;
              background: #ae954f;
            }
            .circle {
              position: relative;
              width: 20px;
              height: 20px;
              left: 6px;
              box-sizing: border-box;
              border: 2px solid #ae954f;
            }
            .circle::after {
              content: "";
              position: absolute;
              width: 10px;
              height: 10px;
              top: 3px;
              left: 3px;
            }
            p {
              height: 19px;
              padding-top: 12px;
              font-weight: 600;
              color: rgba(182, 159, 96, 1);
              width: 124px;
              text-align: center;
              padding-bottom: 30px;
              padding-left: 0;
              font-size: 12px;
              margin-left: -41px;
              font-family: PingFangSC-Semibold;
            }
          }
        }
        ul {
          width: 100%;
          margin: 0 auto;
          padding-top: 39px;
          padding-bottom: 32px;
          li {
            width: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            height: 290px;
            h2 {
              height: 30px;
              line-height: 30px;
              font-size: 21px;
              padding-bottom: 7px;
            }
            p {
              width: 100%;
              font-size: 12px;
              line-height: 28px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
              padding-bottom: 10px;
            }
            img {
              width: 90%;
              height: auto;
            }
          }
          li:nth-of-type(odd) {
            float: left;
            width: 50%;
            text-align: right;
            margin-left: 0;
            align-items: flex-end;
            padding-right: 7%;
          }
          li:nth-of-type(even) {
            float: right;
            width: 50%;
            text-align: left;
            margin-right: 0;
            padding-left: 7%;
            align-items: flex-start;
          }
          li:nth-of-type(1) {
            width: 50%;
            margin-top: 0px;
            height: 340px;
          }
          li:nth-of-type(2) {
            margin-top: 194px;
          }
        }
      }
    }
  }
}
@media (min-width: 376px) and (max-width: 414px) {
  .page-aboutUs {
    .china-section {
      .p-div {
        height: 646px;
        .right {
          .bg {
            height: 200px;
            left: 10px;
            top: 18px;
          }
          img {
            top: -222px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .right {
          h2 {
            padding-top: 20px;
          }
          p {
            padding-top: 20px;
          }
        }
        .left {
          .bg {
            top: 58px;
            height: 297px;
          }
          img {
            top: -318px;
          }
        }
      }
      .p-div.div3 {
        height: 765px;
        .right {
          .bg {
            height: 227px;
            left: 10px;
            top: 16px;
          }
          img {
            top: -222px;
            left: 0;
          }
        }
      }
    }
  }
}
@media (min-width: 321px) and (max-width: 360px) {
  .page-aboutUs {
    .china-section {
      .p-div {
        height: 670px;
        .left {
          h2 {
            height: 60px;
          }
        }
        .right {
          .bg {
            height: 199px;
            left: 10px;
            top: 13px;
          }
          img {
            top: -199px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .left {
          .bg {
            top: 56px;
            height: 260px;
          }
        }
      }
      .p-div.div3 {
        height: 730px;
        .right {
          .bg {
            height: 199px;
            left: 10px;
            top: 10px;
          }
          img {
            top: -199px;
            left: 0;
          }
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 320px) {
  .page-aboutUs {
    .china-section {
      .p-div {
        height: 700px;
        .left {
          p {
            height: 415px;
          }
          h2 {
            height: 60px;
          }
        }
        .right {
          .bg {
            height: 175px;
            left: 10px;
            top: 13px;
          }
          img {
            top: -175px;
            left: 0;
          }
        }
      }
      .p-div2 {
        .left {
          .bg {
            top: 68px;
            height: 243px;
          }
          img {
            top: -227px;
          }
        }
      }
      .p-div.div3 {
        height: 763px;
        .left {
          p {
            height: 487px;
          }
          h2 {
            height: 90px;
          }
        }
        .right {
          .bg {
            height: 175px;
            left: 10px;
            top: 10px;
          }
          img {
            top: -175px;
            left: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/china.vue